import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

// Modules
import { RouterModule } from "@angular/router";
import { NgxPaginationModule } from "ngx-pagination";
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

// Directives
import { BlockCopyPasteDirective } from './directives/block-copy-paste.directive';
import { CapslockOnDirective } from './directives/capslock-on.directive';
import { DragAndDropDirective } from './directives/drag-and-drop.directive';

// Components
import { LoadingComponent } from "./loading/loading.component";
import { PaginatorComponent } from "./paginator/paginator.component";
import { NoResultsComponent } from './no-results/no-results.component';
import { BackButtonDirective } from './directives/back-button.directive';
import { AmountDirective } from './directives/amount.directive';
import { AlertSuccessComponent } from './alert-success/alert-success.component';
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { AlertComponent } from "./alert/alert.component";
import { DatepickerComponent } from './datepicker/datepicker.component';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    AlertComponent,
    PaginatorComponent,
    LoadingComponent,
    NoResultsComponent,
    BlockCopyPasteDirective,
    CapslockOnDirective,
    DragAndDropDirective,
    BackButtonDirective,
    AmountDirective,
    AlertSuccessComponent,
    DatepickerComponent
  ],
  imports: [CommonModule, RouterModule, NgxPaginationModule, BsDatepickerModule, ReactiveFormsModule],
  exports: [
    HeaderComponent,
    FooterComponent,
    AlertComponent,
    PaginatorComponent,
    LoadingComponent,
    NoResultsComponent,
    AlertSuccessComponent,
    DatepickerComponent,
    BlockCopyPasteDirective,
    CapslockOnDirective,
    DragAndDropDirective,
    BackButtonDirective,
    AmountDirective
  ],
})
export class SharedModule {}
